import { Customer } from '@medusajs/medusa'
import { atom } from 'jotai'

import { authenticationService } from '@/domain/Authentication'

export const isCartDrawerOpenAtom = atom<boolean>(false)

export const appLoadingAtom = atom<boolean>(false)

export const userLoggedAtom = atom<Customer | null>({} as Customer | null)

export const isLoggedAtom = atom((get) => {
    const user = get(userLoggedAtom)

    return !!user && !!user.id
})

export const signOutAtom = atom(null, async (get, set) => {
    await authenticationService.deleteSession()
    set(userLoggedAtom, null)
})

export const searchVisibleAtom = atom<boolean>(false)

export const cartVisibleAtom = atom<boolean>(false)
